import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { sideBar } from '../../core/constants/sidebar.const';
import { assets } from '../../core/constants/assets.const';
import { AuthService } from '../../services/auth.service';
import { ModuleConst, SchoolManagerUserManagementConst, userRole } from '../../core/constants/keys.constant';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { LoginResponse } from '../../models/auth.model';
import { SideBar } from '../../models/sideBar.model';
import { Router } from '@angular/router';
import { SchoolManagerService } from '../../services/school-manager.service';
import { ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'mindbase-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnDestroy, OnInit {
  private destroy: Subject<boolean> = new Subject<boolean>();
  assetsConst = assets;
  public sideBar = sideBar;
  public innerWidth = 0;
  public sidenavWidth = 5;
  protected moduleConst = ModuleConst;
  private subscriptionSubject$: Subscription;
  protected adminLogo: any;
  subscriptionStatus!: number;
  subscriptionStatusConst = [2, 4, 5];
  constructor(
    public _authService: AuthService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private schoolManagerService: SchoolManagerService,
    private toasterService: ToasterService
  ) {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.handleSideBar(res);
        }
      });
    // multitenant to single tenant
    // multitenant to singletenant
    // this.subscriptionStatus = Number(localStorage['subscriptionStatus']);
    this.subscriptionStatus = 0;
  }
  increase(): void {
    this.sidenavWidth = 15;
  }
  decrease(): void {
    this.sidenavWidth = 4;
  }

  @HostListener('window', ['$event'])
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 1199.98) {
      this._authService.toggleSidebarView();
    }
  }

  ngOnInit(): void {
    // this.webLogo = JSON.parse(localStorage.getItem('webSettings') || '{}')?.adminLogo || '';
    this.adminLogo = this.getWebSettings()?.adminLogo || this.assetsConst.logo;
    setTimeout(() => {
      const updatedLogo = this.getWebSettings()?.adminLogo;
      if (updatedLogo) {
        this.adminLogo = updatedLogo;
        this.cdr.detectChanges();
      }
    }, 500); 
  }

  getWebSettings(): any {
    const val = localStorage.getItem('webSettings');
    if (!val || val === 'undefined') return {};
    try {
      return JSON.parse(val);
    } catch {
      return {};
    }
  }

  private handleSideBar(res: LoginResponse): void {
    if (res.role === userRole.SUBADMIN) {
      this.subAdminRoleHandler(res);
    } else if (res.role === userRole.SCHOOL_MANAGER) {
      this.schoolManagerRoleHandler();
    } else {
      this.sideBar.forEach((el: SideBar) => {
        el.isView = el.isAdd = el.isEdit = el.isDelete = true;
        el.subMenuItems?.forEach((item: SideBar) => {
          item.isView = item.isAdd = item.isEdit = item.isDelete = true;
        });
      });
    }
  }


  private schoolManagerRoleHandler(): void {
    this.sideBar = [
      // {
      //   label: 'Dashboard',
      //   path: '/school-manager/dashboard',
      //   img: this.assetsConst.DashboardIcon,
      //   isSubMenu: false,
      //   // sideBarId: this.moduleConst.SchoolManagerDashboard,
      //   isView: true,
      //   isAdd: false,
      //   isEdit: false,
      //   isDelete: false
      // },
      {
        label: 'SchoolOverview',
        path: '/school-manager/schools-dashboard/overview',
        img: this.assetsConst.schoolIcon,
        isSubMenu: false,
        sideBarId: this.moduleConst.SchoolsDashboardOverview,
        isView: true,
        isAdd: false,
        isEdit: false,
        isDelete: false
      },
      {
        label: 'UserManagement',
        img: this.assetsConst.UsersIcon,
        isSubMenu: true,
        sideBarId: this.moduleConst.SchoolManagerUserManagement,
        isView: true,
        subMenuItems: [
          {
            label: 'Students',
            path: '/school-manager/user-management/students',
            isSubMenu: false,
            sideBarId: +SchoolManagerUserManagementConst.Students,
            isView: true
          },
          {
            label: 'Teachers',
            path: '/school-manager/user-management/teachers',
            isSubMenu: false,
            sideBarId: +SchoolManagerUserManagementConst.Teachers,
            isView: true
          },
          {
            label: 'Counsellors',
            path: '/school-manager/user-management/counsellors',
            isSubMenu: false,
            sideBarId: +SchoolManagerUserManagementConst.Counsellors,
            isView: true
          }
        ]
      },
      // Temporarily disabled for every school (not clickable). To restore the per-school premium gate,
      // drop `isLocked: true` below and re-enable the applyNationalBenchmarksAccess() call.
      {
        label: 'NationalBenchmarks',
        path: '/school-manager/schools-dashboard/national-benchmarks',
        img: this.assetsConst.AnalyticIcon,
        isSubMenu: false,
        sideBarId: this.moduleConst.SchoolsDashboardBenchmarks,
        isView: true,
        isAdd: false,
        isEdit: false,
        isDelete: false,
        isLocked: true
      }
    ];
    // this.applyNationalBenchmarksAccess();
  }

  /** Padlocks National Benchmarks when the school is locked. Stays open if the check fails — open is the default. */
  private applyNationalBenchmarksAccess(): void {
    this.schoolManagerService
      .getNationalBenchmarksAccess()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: access => {
          const item = this.sideBar.find(el => el.sideBarId === this.moduleConst.SchoolsDashboardBenchmarks);
          if (item) {
            item.isLocked = access?.isPremium === false;
            item.lockedReason = item.isLocked ? access.lockedReason : null;
            this.cdr.markForCheck();
          }
        }
      });
  }

  private subAdminRoleHandler(res: LoginResponse): void {
    const removeableItems = new Set([this.moduleConst.ManageSubAdmin]);

    // Build from the static config on every call so flags set for another role (or an admin session
    // in the same tab) never leak into this sub-admin's menu.
    this.sideBar = sideBar
      .filter(item => !removeableItems.has(item.sideBarId))
      .map((item): SideBar | null => {
        const current = res.accessRole?.permissions?.find(
          perm => Number(perm.sideBarId) === item.sideBarId
        );
        // A module missing from the role was never granted.
        if (!current?.isView) {
          return null;
        }
        const subMenuItems = item.subMenuItems?.length && current.subMenuItems?.length
          ? item.subMenuItems
            .map(staticSub => {
              const match = current.subMenuItems?.find(
                s => Number(s.sideBarId) === Number(staticSub.sideBarId)
              );
              return {
                ...staticSub,
                isView: !!match?.isView,
                isAdd: !!match?.isAdd,
                isEdit: !!match?.isEdit,
                isDelete: !!match?.isDelete
              };
            })
            .filter(sub => sub.isView)
          : item.subMenuItems?.map(staticSub => ({
            ...staticSub,
            isView: current.isView,
            isAdd: current.isAdd,
            isEdit: current.isEdit,
            isDelete: current.isDelete
          }));
        return {
          ...item,
          isView: current.isView,
          isAdd: current.isAdd,
          isEdit: current.isEdit,
          isDelete: current.isDelete,
          subMenuItems
        };
      })
      .filter((item): item is SideBar => item !== null)
      .filter(item => !item.isSubMenu || !!item.subMenuItems?.length);
  }


  onItemClick(item: SideBar): void {
    if (item.isLocked) {
      if (item.lockedReason) {
        this.toasterService.infoToastr(item.lockedReason);
      }
      return;
    }
    if (!this.subscriptionStatusConst.includes(this.subscriptionStatus)) {
      this.router.navigate([item.path]);
    }
  }
  toggleSidenavWeb(): void {
    this._authService.toggleSidebarView();
  }


  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.complete();
    this.subscriptionSubject$.unsubscribe();
  }
}
